<template>
	<div class="ui-card" :style="`width: ${width}`">
		<ui-form @submit="onSubmit">
			<div class="p-4">
				<slot/>
			</div>

			<div v-if="hasActions" class="ui-card-actions px-4 py-4">
				<slot name="actions"/>
			</div>
		</ui-form>
	</div>
</template>

<script>
export default {
	props: {
		width: {
			type: String,
			default: '100%'
		}
	},

	computed: {
		hasActions() {
			return Boolean(this.$slots.actions);
		}
	},

	methods: {
		onSubmit() {
			this.$emit('submit');
		}
	}
};
</script>

<style lang="scss">
.ui-card {
  background-color: #363a41;
  border-radius: 3px;
  border: 1px solid #4a4e58;
  color: white;
  margin: auto;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.0625em 0.0625em, rgba(0, 0, 0, 0.25) 0px 0.125em 0.5em, rgba(255, 255, 255, 0.1) 0px 0px 0px 1px inset;

}

.ui-card-actions {
  background-color: #2d3138;
  border-top: 1px solid #4a4e58;
}
</style>
